import React from 'react';

import './universalBackdrap.css';

const backdrop = (props) => {
    const cssClasses = ['UBackdrop', props.open? 'UBackdropOpen' : 'UBackdropClosed'];

    return <div className={cssClasses.join(' ')}></div>;
};

export default backdrop;